import {
    GET_MAQUINA_DETALLES, ADD_NEW_MAQUINA, ADD_ITV_MAQUINA, MODIFY_ITV_MAQUINA, DELETE_ITV_MAQUINA
} from '../constants/action_types';

const initialState = { maquinaItvs: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINA_DETALLES:

            return {
                maquinaItvs: [],
                isLoading: true
            };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            return {
                maquinaItvs: action.payload.data.itVs,
                isLoading: false
            };


        case ADD_ITV_MAQUINA:

            const newArr = [...state.maquinaItvs, action.payload]

            return {
                maquinaItvs: newArr,
                isLoading: false
            };


        case DELETE_ITV_MAQUINA:

            return {
                maquinaItvs: state.maquinaItvs.filter(itV => itV.id !== action.payload.id),
                isLoading: false
            };


        case MODIFY_ITV_MAQUINA:

            return {
                maquinaItvs: state.maquinaItvs.map((itv) => {
                    if (itv.id !== action.payload.id) return itv;
                    else return action.payload;
                }),
                isLoading: false
            };


        case ADD_NEW_MAQUINA:

            return initialState;


        default:

            return state;
    }

}